// extracted by mini-css-extract-plugin
export var alt = "ParagraphVideoBlock-module--alt--9ee91";
export var container = "ParagraphVideoBlock-module--container--00d0d";
export var desktopOnly = "ParagraphVideoBlock-module--desktopOnly--c6df9";
export var main = "ParagraphVideoBlock-module--main--b81bb";
export var mobileOnly = "ParagraphVideoBlock-module--mobileOnly--70d97";
export var textLeft = "ParagraphVideoBlock-module--textLeft--efe07";
export var visuallyHidden = "ParagraphVideoBlock-module--visuallyHidden--fb4bc";